import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import SEO from "@/components/SEO";

export default function GrievanceRedressal() {
  const [businessName, setBusinessName] = useState("Nityavastra");

  useEffect(() => {
    let active = true;
    api.get("/config/business-identity")
      .then(({ data }) => {
        if (active && data?.public_business_name) {
          setBusinessName(data.public_business_name);
        }
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);

  return (
    <main className="min-h-[70vh] bg-[#FFF9F0] px-4 pb-16 pt-[132px] sm:px-8">
      <SEO
        title="Grievance Redressal"
        description="Contact Nityavastra's Grievance Officer about an order or customer complaint."
      />
      <div className="mx-auto max-w-3xl rounded-3xl border border-[#D9C7AB] bg-white p-6 shadow-sm sm:p-10">
        <p className="text-xs uppercase tracking-[0.25em] text-[#7C1F30]">
          Customer care
        </p>
        <h1 className="mt-3 font-serif text-4xl text-[#2A1508]">
          Grievance Redressal
        </h1>
        <p className="mt-5 text-sm leading-7 text-[#604D40]">
          If you have a concern about a product, order, delivery, return, refund,
          payment, or your experience with {businessName}, please send us the details.
          Include your order number, if available. We will give you a ticket number
          so you can refer to the complaint later.
        </p>

        <section className="mt-8 rounded-2xl bg-[#FAF3E7] p-5">
          <h2 className="font-serif text-2xl text-[#2A1508]">Grievance Officer</h2>
          <dl className="mt-4 space-y-3 text-sm text-[#49372D]">
            <div><dt className="font-semibold">Name</dt><dd>Ujjal Dutta</dd></div>
            <div><dt className="font-semibold">Designation</dt><dd>Grievance Officer</dd></div>
            <div><dt className="font-semibold">Email</dt><dd><a className="text-[#7C1F30] underline" href="mailto:admin@nityavastra.com">admin@nityavastra.com</a></dd></div>
            <div><dt className="font-semibold">Phone</dt><dd><a className="text-[#7C1F30] underline" href="tel:+918281037035">+91 8281037035</a></dd></div>
          </dl>
        </section>

        <section className="mt-8 space-y-3 text-sm leading-7 text-[#604D40]">
          <h2 className="font-serif text-2xl text-[#2A1508]">How to raise a complaint</h2>
          <p>
            Use the <Link to="/contact" className="font-semibold text-[#7C1F30] underline">Contact form</Link>,
            email the Grievance Officer, or call the number above. Customers who
            are signed in can also <Link to="/help-support" className="font-semibold text-[#7C1F30] underline">raise and follow a support ticket</Link>.
          </p>
          <p>
            We acknowledge consumer complaints within 48 hours and work to
            resolve them within one month of receipt. Our customer support team
            also aims to send a first human reply within 24 hours.
          </p>
          <p>
            Please keep your ticket number and any order details. You can reply
            to our support messages if more information is needed.
          </p>
        </section>
      </div>
    </main>
  );
}
